// packages block
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Typography } from "@material-ui/core";
// common block
import "./style.css";
import { TableHeader } from "./components";
import { ManagementTable } from "../../../components/managementTable";
// constants, theme, utils and api block
import { searchStudents } from "../../../api/student";
import { setAlert } from "../../../redux/reducers/alert";
import { getAllStudents } from "../../../api/student";
import {
  addMultipleInvoices,
  notifyParentsNotifications,
} from "../../../api/invoices";
import {
  AddInvoiceDialog,
  FileUploader,
  NotifyParentDialog,
  OnSuccessDialog,
} from "../../../components/dialogs";
import { getAllSchools } from "../../../api/schools";
import { capitalizeFirstLetter } from "../../../util/Date";
import bulkBalance from "../../../assets/csv/bulk-balance.csv";
import { PreUpdateDialog } from "../../../components/dialogs/preUpdateDialog";
import { setLoadingForAllSyncButtons } from "../../../redux/reducers/allSyncButtonsLoader";

export const StudentInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [studentId, setStudentId] = useState(null);
  const [isNotifyParentDialog, setIsNotifyparentDialog] = useState(false);
  const [isAddInvoiceDialogVisible, setIsAddInvoiceDialogVisible] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(null);
  const [isEditedItem, setIsEditedItem] = useState(null);
  const [isFileUploaderVisible, setIsFileUploaderVisible] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [isOnSuccessDialogVisible, setIsOnSuccessDialogVisible] =
    useState(false);
  const [startEntry, setStartEntry] = useState(1);
  const [endEntry, setEndEntry] = useState(10);
  const [selectedIds, setSelectedIds] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [selectedRadio, setSelectRadio] = useState("balance");
  const { token, schoolId, role, id } = useSelector((state) => state.user);
  const [payeeType, setPayeeType] = useState("STUDENT");
  const [isPreUpdateDialogVisible, setIsPreUpdateDialogVisible] =
    useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let limit = 10;
  const tablePayeeType = capitalizeFirstLetter(payeeType?.toLowerCase());
  const payeeTypeForManagers =
    role === "superadmin" ? "" : `(${tablePayeeType})`;
  const INVOICE_MANAGMENT_COLUMNS = [
    {
      id: "studentRegNo",
      numeric: false,
      disablePadding: true,
      label: `${t("text_payee_id")} ${payeeTypeForManagers}`,
    },
    { id: "name", numeric: false, disablePadding: true, label: t("text_name") },
    {
      id: "amount",
      numeric: false,
      disablePadding: true,
      label: t("text_total_balance_amount"),
    },
    {
      id: "dueDate",
      numeric: false,
      disablePadding: true,
      label: t("text_due_date"),
    },
    { id: "actions", numeric: false, disablePadding: true, label: "" },
  ];

  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];

  const openPreUpdateDialog = (event) => {
    event.stopPropagation();
    setIsPreUpdateDialogVisible(true);
  };
  const closePreUpdateDialog = () => setIsPreUpdateDialogVisible(false);
  const closeAddInvoiceDialog = () => {
    setIsAddInvoiceDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const backToPreAddDialog = () => {
    closeAddInvoiceDialog();
  };

  const openNotifyParntDialog = () => {
    setIsNotifyparentDialog(true);
  };
  const closeNotifyParentDialog = () => {
    setIsNotifyparentDialog(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };
  const continueNotifyParentDialog = (
    pushNotification,
    email,
    sms,
    watsapp
  ) => {
    setIsNotifyparentDialog(false);
    notifyParents(pushNotification, email, sms, watsapp);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const notifyParents = async (pushNotification, email, sms, watsapp) => {
    try {
      setLoading(true);
      const payload = {
        selectedStudentIds: selectedIds,
      };
      const response = await notifyParentsNotifications(
        payload,
        sms,
        email,
        pushNotification,
        watsapp,
        token
      );
      setIsOnSuccessDialogVisible(true);
      setLoading(false);
    } catch (error) {}
  };

  const showErrorAlert = (message) => {
    if (!message) message = "Something went wrong";
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const goHome = () => {
    window.location.reload();
  };

  const viewDetailWithGenrateDialogue = async (id) => {
    history.push({
      pathname: `/students/student-detail/${id}`,
      state: {
        openGenerateIvoiceDialog: true,
      },
    });
  };

  const handlePage = (pageNumber) => setPage(pageNumber);

  useEffect(() => {
    if (role === "manager") {
      setSelectRadio("balance");
    }
  }, [role]);

  useEffect(() => {
    if (searchString === "") {
      fetchStudents();
    } else {
      setLoading(true);

      (async () => {
        try {
          setStudentList([]);
          const response = await searchStudents(searchString, token);
          if (response && response.status) {
            setTotalCount(response?.getStudent.count);
            setStudentList(response?.getStudent.rows);
            if (
              response.getStudent.count === 0 ||
              response.getStudent.rows.length === 0
            ) {
              setStudentList([]);
              showErrorAlert(t("text_records_not_found"));
            }
          }
          setLoading(false);
        } catch (err) {
          showErrorAlert(err.message || t("text_error_in_searching_students"));
          setLoading(false);
        }
      })();
    }
  }, [searchString, page]);

  const successCallback = async () => {
    closeAddInvoiceDialog();
    const response = await getAllStudents(page, token);
    if (response && response.status) {
      setStudentList(response?.students.rows);
      setTotalCount(response?.students.count);
    }

    setIsEditedItem(null);
  };

  const editStudent = (item) => {
    setIsEditedItem(item.student);
  };

  const handleSelection = (ids) => {
    setSelectedIds(ids);
  };
  const editInvoice = (item) => {
    setIsEditedItem(item);
    setIsAddInvoiceDialogVisible(true);
  };

  const editedSuccessCallback = (invoice) => {
    for (let i = 0; i < invoices.length; i++) {
      if (invoices[i].id === invoice.id) {
        invoice.student = invoices[i].student;
        studentId = invoices[i].student.id;
        invoices[i] = invoice;
      }
    }
    setInvoices(invoices);
    closeAddInvoiceDialog();
    viewItem(studentId);
  };

  const viewItem = async (id) => history.push(`/students/student-detail/${id}`);

  const handleFileUpload = async (file) => {
    setIsFileUploaderVisible(true);

    try {
      setLoading(true);
      dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: true }));

      const response = await addMultipleInvoices(
        file,
        token,
        schoolId,
        selectedRadio
      );

      if (response.length === 0) {
        showErrorAlert("No unique invoice found");
      } else {
        setInvoices([...response, ...invoices]);
        showSuccessAlert("Balances added successfully");
      }
      setIsFileUploaderVisible(false);
      dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: false }));
      setLoading(false);
    } catch (err) {
      dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: false }));
      showErrorAlert(err.message || "Error in multiple balance updaing");
      setIsFileUploaderVisible(false);
      setLoading(false);
    }
  };

  const handleSearching = (value) => {
    setPage(0);
    setTotalCount(0);
    setSearchString(value);
  };

  const fetchStudents = async () => {
    try {
      const response = await getAllStudents(page, token, limit);
      setStartEntry(page === 0 ? 1 : page * limit + 1);
      setEndEntry(
        (page + 1) * limit > response?.students.count
          ? response.students.count
          : (page + 1) * limit
      );
      if (response && response.status) {
        setStudentList(response?.students.rows);
        setTotalCount(response?.students.count);
      } else {
        showErrorAlert(response?.message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      showErrorAlert(
        e || e.message || t("text_something_went_wrong_try_again_later")
      );
    }
  };

  const fetchSchools = async () => {
    try {
      const payload = {
        role,
        id,
        schoolId,
      };
      const response = await getAllSchools(payload, token);

      if (response?.status) {
        setPayeeType(response?.schools[0].payeeType);
      }
    } catch (e) {}
  };

  useEffect(() => {
    fetchSchools();
  }, []);

  return (
    <div className="school-management-page">
      <Typography
        variant="h4"
        style={{ fontFamily: "Monsteric, sans-serif", marginBottom: 20 }}
      >
        {t("text_balance_management")}
      </Typography>

      <div className={"school-management-container"}>
        <TableHeader
          handleSearching={handleSearching}
          handleFileUpload={handleFileUpload}
          openNotifyParentDialog={openNotifyParntDialog}
          selectedIds={selectedIds}
          open={isFileUploaderVisible}
          setLoading={setLoading}
          schoolId={schoolId}
          handleUpdate={openPreUpdateDialog}
        />

        {loading ? (
          <div className={"school-loader"}>
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_balances")}
          </div>
        ) : (
          <ManagementTable
            handleSelection={handleSelection}
            pageNumber={page}
            handlePage={handlePage}
            totalCount={totalCount}
            tableFor="balance"
            data={studentList}
            columns={INVOICE_MANAGMENT_COLUMNS}
            editItem={editStudent}
            editInvoice={editInvoice}
            viewItem={viewItem}
            startEntry={startEntry}
            endEntry={endEntry}
          />
        )}
      </div>

      {isAddInvoiceDialogVisible && (
        <AddInvoiceDialog
          selectedForm={selectedRadio}
          title={
            isEditedItem
              ? "Edit Balance"
              : selectedRadio === "balance" && role === "manager"
              ? t("text_update_balance")
              : t("text_add_invoice")
          }
          handleClose={
            isEditedItem ? closeAddInvoiceDialog : backToPreAddDialog
          }
          open={isAddInvoiceDialogVisible}
          successCallback={successCallback}
          editedSuccessCallback={editedSuccessCallback}
          isEditedItem={isEditedItem}
          stdId={studentId}
          fetchStudents={studentList}
        />
      )}

      {isOnSuccessDialogVisible && (
        <OnSuccessDialog
          handleClose={closeAddInvoiceDialog}
          open={isOnSuccessDialogVisible}
          isEditedItem={studentId}
          goHome={goHome}
          viewDetailWithGenrateDialogue={viewDetailWithGenrateDialogue}
          invoiceTitle={t("text_notifyParent")}
        />
      )}

      {isNotifyParentDialog && (
        <NotifyParentDialog
          title={t("text_notify_parents")}
          open={isNotifyParentDialog}
          handleClose={closeNotifyParentDialog}
          handleContinue={continueNotifyParentDialog}
        />
      )}
      <PreUpdateDialog
        title={t("text_update_balance")}
        multipleTitle={"Bulk Balance Update"}
        handleClose={closePreUpdateDialog}
        open={isPreUpdateDialogVisible}
        // addSchool={openAddSchoolDialog}
        addButtonTitle={t("text_add_student")}
        handleFileUpload={handleFileUpload}
        backbut={true}
        url={bulkBalance}
      />
      <FileUploader open={isFileUploaderVisible} loading={loading} />
    </div>
  );
};
